import type { VesselCallError } from "@features/vessel-call/vessel-call-status/VesselCallStatus.types.tsx";
import type { CloseVesselCallByIdArgs } from "@services/vesselCall/types";
import { closeVesselCallById } from "@services/vesselCallApi";
import { useMutation } from "@tanstack/react-query";
import { runTransaction } from "@telemetry/runTransaction";

export const useCloseVesselCall = ({
  handleSuccess,
  handleError,
}: {
  handleSuccess: (status?: string) => void;
  handleError: (error: VesselCallError) => void;
}) => {
  const closeCallMutation = useMutation({
    mutationFn: (variables: Parameters<typeof closeVesselCallById>[0]) =>
      runTransaction(
        {
          module: "vessel_call",
          screen: "VesselCallStatus",
          action: "close_vessel_call",
          entityType: "vessel_call",
        },
        (transactionId) =>
          closeVesselCallById({ ...variables, ...(transactionId ? { transactionId } : {}) }),
      ),
    onSuccess: () => handleSuccess("CLOSED"),
    onError: (error: VesselCallError) => handleError(error),
  });

  const closeCall = ({
    service,
    vesselCallId,
    payload,
  }: {
    service: string;
    vesselCallId: string;
    payload: CloseVesselCallByIdArgs;
  }) => {
    closeCallMutation.mutate({ service, vesselCallId, payload });
  };

  return { closeCall };
};
